import { CookieTractorConfig } from '@habity/types';

// Track if CookieTractor has been initialized
let isInitialized = false;

export const useCookieTractor = () => {
  const init = (config: CookieTractorConfig) => {
    // Only run in browser environment
    if (typeof window === 'undefined') return;

    // Prevent multiple initializations
    if (isInitialized) return;

    try {
      const { apiKey } = config;

      if (!apiKey) {
        console.error('CookieTractor API key is missing');
        return;
      }

      // Add the main CookieTractor script
      const mainScript = document.createElement('script');
      mainScript.src = 'https://cdn-eu.cookietractor.com/cookietractor.js';
      mainScript.async = true;
      mainScript.setAttribute('data-lang', 'sv-SE');
      mainScript.setAttribute('data-id', apiKey);
      document.head.appendChild(mainScript);

      // Add the declaration script
      const declarationScript = document.createElement('script');
      declarationScript.src =
        'https://cdn-eu.cookietractor.com/cookietractor-declaration.js';
      declarationScript.async = true;
      declarationScript.defer = true;
      declarationScript.setAttribute('data-lang', 'sv-SE');
      declarationScript.setAttribute('data-id', apiKey);
      document.head.appendChild(declarationScript);

      isInitialized = true;
    } catch (error) {
      console.error('Error initializing CookieTractor:', error);
    }
  };

  return {
    init,
  };
};
